import React,{Component} from 'react';
import { NavBar,InputItem,Toast,Modal} from 'antd-mobile';
import {getDiscount} from "../../service/memberService";
import './style.less'
import {connect} from "react-redux";
const chengchequan = require('../../common/image/chengchequan.png');
const yhq = require('../../common/image/yhq.png');
const shurukuang = require('../../common/image/shurukuang.png');
const alert = Modal.alert;
@connect(
    state => ({userInfo: state.userInfo})
)
export default class GetCoupon extends Component{
    constructor(props) {
        super(props);
        this.state={
            phone:"",
            modal:false,
        }
    }
    componentDidMount() {}
    invite(){
        let code = window.location.href.split('/')[4];
        if(this.state.phone == ""){
            Toast.info("请输入手机号码！");
            return
        }
        Toast.loading("",0);
        let params={
            phone:this.state.phone.replace(/\s/ig, ''),
            code:code.split('?')[0],
            companyId:window.location.href.split('?')[1],
            type:3,
        };
        console.log(params)
        getDiscount(params).then((res)=>{
            if(res.data.code == '0000'){
                Toast.hide();
                this.setState({modal:true});
            }else{
                Toast.hide();
                alert(null,res.data.msg, [
                    { text: '关闭', onPress: () => this.setState({modal:false}) },
                ]);
            }
        })
    }
    render(){
        return(
            <div className="getCoupon">
                <NavBar
                    className="navBar"
                    mode="light"
                    // icon={<i className="icon iconfont iconfanhui" onClick={() =>this.props.history.goBack()}/>}
                >优惠券领取</NavBar>
                <div className="content">
                    <img src={yhq} alt=""/>
                    <div className="formBox">
                        <img src={shurukuang} alt=""/>
                        <div className="input">
                            <InputItem
                                clear
                                placeholder="请输入手机号"
                                type="phone"
                                onChange={(v)=>this.setState({phone:v})}
                            >
                            </InputItem>
                            <button onClick={()=>this.invite()}>立即领取</button>
                        </div>
                    </div>
                    <div className="couponsInfo">
                        <div className="title">优惠券领取说明</div>
                        <div className="info">
                            <p>1.一个手机号只可领取一次优惠券；</p>
                            <p>2.新用户请先关注民途出行公众号后才可领取；</p>
                            <p>3.手机号必须与微信注册手机号一致。</p>
                        </div>
                    </div>
                </div>
                <Modal
                    visible={this.state.modal}
                    className="couponModal"
                >
                    <div className="">
                        <img src={chengchequan} className="bg"/>
                        <i className="icon iconfont iconchacha1" onClick={()=>this.setState({modal:false})}></i>
                        {/*<button onClick={()=>this.employ()}>去使用</button>*/}
                    </div>
                </Modal>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/GetCoupon/index.js